import {Grid} from '@jobseeker/lotus/foundations';
import {Box, Card, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import HashTag from '@jobseeker/lotus/assets/icons/resources/hashtag.svg';
import NoJobFound from '@jobseeker/lotus/assets/images/resources/no_jobs_found.svg';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {getOldLink} from '@jobseeker/lotus/utils';
import {JOBFEED, LOCATION_BASED} from '@constants';
import {categories} from '@components/HomeV2/constants';
import Link from 'next/link';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

interface PropType {
  noTags: boolean;
  title: string;
  page?: string;
}
const JobFeedEmpty = ({noTags, title, page}: PropType) => {
  return (
    <>
      {isAppIimjobs ? (
        <Card
          sx={{
            boxShadow: 2,
            borderRadius: 4,
            height:
              isAppIimjobs && page === LOCATION_BASED ? 'min-content' : '100%',
          }}
        >
          <Grid
            container
            sx={{
              px: 2,
              mt: 3,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 3,
              '@media (width:1280px)': {
                gap: 3,
              },
              '@media (width:1336px)': {
                gap: 8,
              },
              '@media (width:1440px)': {
                gap: 12,
              },
            }}
            gap={
              isAppIimjobs && page === LOCATION_BASED
                ? 0
                : {xxs: 10, md: 6, lg: 23}
            }
            color="gray.dark"
          >
            <Grid item>
              <Typography
                component={'h1'}
                fontSize={{xxs: 16, lg: 20}}
                fontWeight={{xxs: 600, lg: 500}}
                display="flex"
                color="secondary.dark"
                sx={{wordWrap: 'break-word', textTransform: 'capitalize'}}
              >
                {page === JOBFEED ? title?.replace('Jobs', '') : title}&nbsp;
              </Typography>

              {isAppIimjobs && page === LOCATION_BASED && (
                <Box data-nosnippet="true">
                  <Typography
                    color="secondary.main"
                    fontSize={{xxs: 14, md: 16}}
                    fontWeight={400}
                    mt={2}
                  >
                    {`There are no jobs available from "${title
                      ?.split('Jobs in ')
                      .pop()}". 
        However, you may browse jobs from nearby ${title
          ?.split('Jobs in ')
          .pop()}.`}
                  </Typography>
                </Box>
              )}
            </Grid>

            <Grid
              item
              xxs={12}
              display={
                isAppIimjobs && page === LOCATION_BASED ? 'none' : 'flex'
              }
              flexWrap={'wrap'}
              sx={{flexDirection: 'column'}}
              justifyContent={'center'}
              alignItems={'center'}
              textAlign={'center'}
              mb={10}
            >
              <Image
                src={noTags ? HashTag : NoJobFound}
                alt={'JobTagsEmpty'}
                width={179}
                height={179}
                object-fit="cover"
              />
              {noTags ? (
                <>
                  <Typography
                    color={'secondary.main'}
                    fontSize={{xxs: 14, md: 18}}
                    fontWeight="medium"
                    mt={2}
                  >
                    {'Personalise your Jobfeed based on your preferences.'}
                  </Typography>
                  <Typography
                    color={'text.secondary'}
                    fontSize={12}
                    fontWeight="medium"
                    mt={0.25}
                  >
                    {
                      'This will help us show you the most relevant job openings.'
                    }
                  </Typography>
                  <Button
                    sx={{
                      width: {md: '125px'},
                      background: '#000',
                      mt: {xxs: 1, md: 2},
                      px: 2,
                      py: 1,
                      height: 'fit-content',
                      backgroundColor: 'secondary.main',
                    }}
                    variant="contained"
                    size="large"
                    onClick={() => {
                      openUrl(getOldLink('/personalize-jobfeed'), '_self');
                    }}
                  >
                    {'Select Tags'}
                  </Button>
                </>
              ) : (
                <>
                  <Typography
                    color={'secondary.main'}
                    fontSize={{xxs: 14, md: 18}}
                    fontWeight="medium"
                    mt={2}
                  >
                    {page === JOBFEED
                      ? 'Personalise your Jobfeed based on your preferences and get more listed jobs'
                      : 'Oops! No Job Found for your search'}
                  </Typography>
                  <Button
                    sx={{
                      '@media (width:1280px)': {
                        width: '95px',
                      },
                      width: {lg: '125px'},
                      background: '#000',
                      mt: {xxs: 1, md: 2},
                      px: 2,
                      py: 1,
                      height: 'fit-content',
                      backgroundColor: 'secondary.main',
                    }}
                    variant="contained"
                    size="large"
                    onClick={() => {
                      if (page === JOBFEED) {
                        openUrl(getOldLink('/personalize-jobfeed'), '_self');
                      } else {
                        window.history.back();
                      }
                    }}
                  >
                    {page === JOBFEED ? 'Select Tags' : 'Go Back'}
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </Card>
      ) : (
        <>
          {page == LOCATION_BASED ? (
            <>
              <Typography
                component="h1"
                fontSize="20px"
                fontWeight={600}
                marginTop={'-30px'}
                marginBottom={'10px'}
                marginLeft={'16px'}
              >
                {title}
              </Typography>

              <Box
                sx={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  my: 1,
                  py: 2,
                  px: 2,
                  marginTop: !isAppIimjobs ? 0 : {xxs: '-40px', md: '-25px'},
                }}
              >
                <Box data-nosnippet="true">
                  <Typography
                    sx={{
                      fontSize: !isAppIimjobs
                        ? '16px'
                        : {xxs: '14px', md: '16px'},
                    }}
                  >
                    {`There are no jobs available from "${title?.split(
                      'Jobs in '
                    )[title?.split('Jobs in ').length - 1]}" However, you may
                    browse jobs from nearby ${title?.split('Jobs in ')[
                      title?.split('Jobs in ').length - 1
                    ]}`}
                  </Typography>
                </Box>
              </Box>
            </>
          ) : (
            <>
              <h1 style={{fontSize: 24, fontWeight: 600, textAlign: 'center'}}>
                {noTags
                  ? 'Glad to see you here !!'
                  : 'Sorry, No result found :('}
                <br></br>
                {noTags ? (
                  <Typography sx={{fontSize: 16}}>
                    You have not created your jobfeed yet. Please select some
                    tags to personalize hirist for you.
                    <Link
                      href="/personalize-jobfeed"
                      style={{textDecoration: 'none'}}
                    >
                      {' '}
                      Click here
                    </Link>
                    , to personalize your jobfeed.
                  </Typography>
                ) : page === 'recruiterJobfeed' ? (
                  `It seems at present there are no active jobs for the recruiter.
                Stay tuned and check out other jobs.`
                ) : (
                  'To get results, Please change your search criteria or filters like posting range from the above.'
                )}
              </h1>
              <Image
                src="https://job-static.hirist.com/V8/static/media/no-jobfeed.7771e408.svg"
                alt="NoNotifications"
                width={350}
                height={400}
                style={{
                  objectFit: 'contain',
                  width: '70%',
                  height: '500px',
                  marginLeft: '15%',
                }}
              />
              {noTags && (
                <Box width={'80%'} ml={'10%'}>
                  <Typography fontWeight={700}>Search Suggesstions:</Typography>

                  {categories.map((c, index) => (
                    <Link
                      key={index}
                      href={`/c/${c.name
                        .toLowerCase()
                        .trim()
                        .replace(/[*%$&']/g, '')
                        .replace(/\s+/g, '-')
                        .replace(/\//g, '-')}-jobs`}
                    >
                      <Button
                        sx={{
                          borderRadius: 5,
                          mr: 1,
                          p: 0.5,
                          px: 1,
                          mt: 1,
                          border: 'solid 1px #dadada',
                          color: 'rgba(0,0,0,0.6)',
                          fontSize: 16,
                          backgroundColor: 'white',
                          '&:hover': {
                            backgroundColor: 'white',
                            color: 'black',
                            border: 'solid 1px #dadada',
                          },
                        }}
                      >
                        {c.name}
                      </Button>
                    </Link>
                  ))}
                </Box>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default JobFeedEmpty;
